import { useTranslation } from "react-i18next";
import ModalShell from "./ModalShell";

// Small confirm dialog used by the Templates pages (activate / discard /
// reset / customize / publish). `children` slots extra content above the buttons.
export default function ConfirmModal({
  title,
  body,
  confirmLabel,
  danger = false,
  busy = false,
  onConfirm,
  onClose,
  children,
}) {
  const { t } = useTranslation();

  return (
    <ModalShell onClose={onClose} busy={busy}>
      <h3 className="text-lg font-bold text-slate-900 pr-8">{title}</h3>
      {body && <p className="mt-2 text-sm text-slate-600 leading-relaxed">{body}</p>}
      {children}
      <div className="mt-6 flex justify-end gap-2">
        <button
          type="button"
          onClick={onClose}
          disabled={busy}
          className="px-4 py-2 rounded-lg text-sm font-semibold text-slate-700 hover:bg-slate-100 disabled:opacity-60"
        >
          {t("common.cancel")}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={busy}
          className={`px-4 py-2 rounded-lg text-sm font-semibold text-white disabled:opacity-60 disabled:cursor-not-allowed transition ${
            danger ? "bg-rose-600 hover:bg-rose-700" : "bg-indigo-600 hover:bg-indigo-700"
          }`}
        >
          {confirmLabel}
        </button>
      </div>
    </ModalShell>
  );
}
